export const BOT_URL =
  "https://chatgpt.com/g/g-Z4g0S22mW-lucas-tu-asistente-virtual";
